import * as React from "react";
const Visitors = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
    fill="none"
    {...props}
  >
    <rect width={32} height={32} fill="#fff" fillOpacity={0.08} rx={16} />
    <mask
      id="aVisitors"
      width={20}
      height={20}
      x={6}
      y={6}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "alpha",
      }}
    >
      <path fill="#D9D9D9" d="M6 6h20v20H6z" />
    </mask>
    <g mask="url(#aVisitors)">
      <path
        fill="#F1F5F9"
        d="M6.833 22.667v-2.334c0-.472.122-.906.365-1.302.243-.395.566-.698.968-.906.861-.43 1.736-.753 2.625-.969a11.465 11.465 0 0 1 2.709-.323c.916 0 1.82.108 2.708.323.889.216 1.764.539 2.625.969.403.208.726.51.969.906s.364.83.364 1.302v2.334H6.833Zm15 0v-2.5c0-.611-.17-1.198-.51-1.76-.34-.563-.823-1.046-1.448-1.449a10.426 10.426 0 0 1 3.75 1.167c.5.278.882.587 1.145.927.264.34.396.712.396 1.115v2.5h-3.333ZM13.5 16a3.21 3.21 0 0 1-2.354-.98 3.21 3.21 0 0 1-.98-2.353c0-.917.327-1.702.98-2.354a3.21 3.21 0 0 1 2.354-.98 3.21 3.21 0 0 1 2.354.98 3.21 3.21 0 0 1 .979 2.354 3.21 3.21 0 0 1-.98 2.354A3.21 3.21 0 0 1 13.5 16Zm8.333-3.333a3.21 3.21 0 0 1-.98 2.354A3.21 3.21 0 0 1 18.5 16c-.153 0-.348-.017-.584-.052a5.133 5.133 0 0 1-.583-.115c.375-.444.663-.937.865-1.479a4.804 4.804 0 0 0 .302-1.687c0-.584-.101-1.146-.302-1.688a4.956 4.956 0 0 0-.865-1.479c.195-.07.389-.115.583-.135.195-.021.39-.032.584-.032a3.21 3.21 0 0 1 2.354.98 3.21 3.21 0 0 1 .979 2.354ZM8.5 21h10v-.667a.812.812 0 0 0-.417-.708 10.862 10.862 0 0 0-2.27-.844 9.667 9.667 0 0 0-4.626 0c-.764.188-1.52.469-2.27.844a.811.811 0 0 0-.417.708V21Zm5-6.667c.458 0 .85-.163 1.177-.49.326-.326.49-.718.49-1.176 0-.459-.164-.851-.49-1.177A1.605 1.605 0 0 0 13.5 11c-.459 0-.851.163-1.177.49-.327.326-.49.718-.49 1.177 0 .458.163.85.49 1.177.326.326.718.49 1.177.49Z"
      />
    </g>
  </svg>
);
export default Visitors;
